import { switcher } from '../utils';
import { ACTIONS } from '../../const';
import R from 'ramda';

const shareSet = R.compose(
    R.uniq,
    R.defaultTo([])
);

const sharingSettings = (data = {}) => {
    return {
        with_all_instructor: true,
        with_all_students: false,
        ...data,
        shared_with: shareSet(data.shared_with),
    };
};

export const defaultSharingSettings = sharingSettings();

export default switcher(
    {},
    {
        [ACTIONS.SET_CONTENT_SHARING](state, action) {
            const {
                content,
                with_all_instructor,
                with_all_students,
                shared_with,
            } = action;

            return {
                ...state,
                [content.id]: sharingSettings({
                    shared_with: shared_with,
                    with_all_instructor,
                    with_all_students,
                }),
            };
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/content/sharing.js